/* tslint:disable */
/* eslint-disable */
/**
 * Funnels API
 * API for managing funnels
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Nature du tunnel, choisie à la création : elle structure tout le parcours. Un tunnel collectif ne se souscrit qu'au travers d'un contrat de groupe, et n'accepte que les supports GROUP / CADRE (le back refuse les supports SOLO, et l'inverse sur un individuel).
 * @export
 */
export const TypeTunnel = {
    Individuel: 1,
    Collectif: 2
} as const;
export type TypeTunnel = typeof TypeTunnel[keyof typeof TypeTunnel];


export function instanceOfTypeTunnel(value: any): boolean {
    for (const key in TypeTunnel) {
        if (Object.prototype.hasOwnProperty.call(TypeTunnel, key)) {
            if (TypeTunnel[key as keyof typeof TypeTunnel] === value) {
                return true;
            }
        }
    }
    return false;
}

export function TypeTunnelFromJSON(json: any): TypeTunnel {
    return TypeTunnelFromJSONTyped(json, false);
}

export function TypeTunnelFromJSONTyped(json: any, ignoreDiscriminator: boolean): TypeTunnel {
    return json as TypeTunnel;
}

export function TypeTunnelToJSON(value?: TypeTunnel | null): any {
    return value as any;
}

export function TypeTunnelToJSONTyped(value: any, ignoreDiscriminator: boolean): TypeTunnel {
    return value as TypeTunnel;
}

